<template>
    <a-spin :spinning="spinning" tip="Carregando...">
        <div v-if="vistorias.length === 0" class="alert alert-warning pd-2 mt-4 mx-4 text-center" role="alert">
            <h4 class="text-center">Não foram encontradas vistorias para a matrícula.</h4>
            <h5 class="text-center">Matrícula nº {{ props.id }}</h5>
        </div>
        <div v-else class="alert alert-primary pd-2 mt-4 mx-4 text-center" role="alert">
            <h4 class="text-center">Clique em uma vistoria para visualizá-la</h4> <br />
            <h5 class="text-center">Inscrição Imobiliária nº {{ props.id }}</h5>
        </div>
        <div class="container w-100 d-flex flex-column">
            <div class="w-100 center-flex" style="flex-direction:column">
                <a-card v-for="vistoria in vistorias" @click="viewInspection(vistoria.id, props.id)" :title="vistoria.status" style="cursor:pointer" size="small"
                    class="inspection-card w-100 my-2"
                    :class="{
                        'status-canceled' : vistoria.status === 'Cancelado',
                        'status-inProgress' : vistoria.status === 'Em andamento',
                        'status-completed' : vistoria.status === 'Completado',
                        'status-migratedData' : vistoria.status === 'Dados migrados'
                    }"
                >
                    <template #extra>
                        <span :style="{
                                    color:
                                        vistoria.status === 'Cancelado' ? '#ff4d4f' :
                                        vistoria.status === 'Em andamento' ? '#d3a43f' :
                                        vistoria.status === 'Completado' ? '#1890ff' :
                                        vistoria.status === 'Dados migrados' ? '#52c41a' : 'black'
                              }"
                        >
                            {{ vistoria.id }}
                        </span>
                    </template>
                    <div style="display:flex; justify-content:space-between">
                        <div>
                            <span>Observações:</span> <br />
                            <span>{{ vistoria.observacoes || "-" }}</span>
                        </div>
                        <span style="font-size: small"
                              :style="{
                                    color:
                                        vistoria.status === 'Cancelado' ? '#ff4d4f' :
                                        vistoria.status === 'Em andamento' ? '#d3a43f' :
                                        vistoria.status === 'Completado' ? '#1890ff' :
                                        vistoria.status === 'Dados migrados' ? '#52c41a' : 'black'
                              }"
                        >
                            {{ vistoria.data }}
                        </span>
                    </div>
                    <hr />
                    <a-card class="status-inProgress" size="small" title="Próxima vistoria" v-if="!!vistoria.agendamento">
                        <template #extra>
                            <span style="color:#d3a43f">{{ vistoria.agendamento.status }}</span>
                        </template>
                        <span>{{ vistoria.agendamento.dataHora }}</span> <br />
                        <span v-if="!!vistoria.agendamento.observacoes">{{ vistoria.agendamento.observacoes }}</span>
                    </a-card>
                    <a-card class="status-canceled" size="small" v-else>
                        <span>Sem agendamento pendente para essa vistoria</span>
                    </a-card>
                </a-card>
            </div>
        </div>
    </a-spin>
</template>

<script setup>
import {onMounted, ref} from "vue";
import {notification} from "ant-design-vue";
import { openNotification } from "../../../utils/utilities";

const spinning = ref(true);
const props = defineProps(["id"]);
const vistorias = ref([])
const canInclude = ref(false)

const viewInspection = (id, propertyId) => {
    window.location.href = `/inspections/view?id=${id}&propertyId=${propertyId}`;
}

onMounted(async () => {
    try {
        vistorias.value = (await window.axios.get(`api/inspections/${props.id}/getAllInspections`)).data.data.sort().filter(vistoria => vistoria.status !== 'Cancelado')

        // id 24 - menu de emissão de vistorias
        canInclude.value = await verifyPermission(24)
        spinning.value = false
    } catch (error) {
        openNotification('error', error)
        spinning.value = false
    }
})

const verifyPermission = async (menuId) => {
    return (await window.axios.get(`/api/configurations/menus/${menuId}/verify-permission-from-user`)).data.data
}
</script>

<style scoped>
.center-flex {
    display: flex;
    justify-content: center;
    align-items: center;
}

.inspection-card {
    transition: all 0.2s;
}

.inspection-card:hover {
    filter: opacity(60%);
}

.status-canceled {
    background-color: #fff1f0;
    border-color: #ff4d4f;
}

.status-inProgress {
    background-color: #fff7e6;
    border-color: #ffc53d;
}

.status-completed {
    background-color: #e6f7ff;
    border-color: #1890ff;
}

.status-migratedData {
    background-color: #f6ffed;
    border-color: #52c41a;
}
</style>